import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React from 'react';

function PageDeveloppeur() {
  return (
    <div>
      <SEO {...SEO_PAGES.developpeur} />
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F7FA' }}>
        <h1 style={{ fontFamily: 'Arial', color: '#002D62' }}>Espace Développeur PEFEP Site 💻</h1>
      </div>
    </div>
  );
}

export default PageDeveloppeur;